import { graphql } from 'gql';

export const catalogRatioGroupsGql = graphql(`
    query catalogRatioGroups($ratioType: RatioTypeEnum!, $where: CatalogRatioGroupDataFilterInput) {
        catalogRatioGroups(ratioType: $ratioType, where: $where) {
            id
            name
            groupType
            parentId
        }
    }
`);

export const catalogRatioTypesGql = graphql(`
    query catalogRatioTypes {
        catalogRatioTypes {
            items
        }
    }
`);

export const catalogRatioGql = graphql(`
    query catalogRatio($id: Int!) {
        catalogRatio(id: $id) {
            data {
                id
                name
                ratioType
                catalogRatioGroupId
                catalogRatioGroupName
                code
                kmat
                ktz
                ktzzpm
                kozp
                knr
                ksp
                kem
            }
        }
    }
`);

export const createCatalogRatioGql = graphql(`
    mutation createCatalogRatio($input: CatalogRatioCreateInput!) {
        createCatalogRatio(input: $input) {
            result
            message
            validation {
                property
                message
            }
            data {
                id
                code
                name
                catalogRatioGroupId
                catalogRatioGroupName
                updatedAt
                ratioType
                kmat
                ktz
                ktzzpm
                kozp
                knr
                ksp
                kem
                justification
                updatedAt
            }
        }
    }
`);

export const updateCatalogRatioGql = graphql(`
    mutation updateCatalogRatio($input: CatalogRatioUpdateInput!) {
        updateCatalogRatio(input: $input) {
            result
            message
            validation {
                property
                message
            }
            data {
                id
                code
                name
                catalogRatioGroupId
                catalogRatioGroupName
                updatedAt
                ratioType
                kmat
                ktz
                ktzzpm
                kozp
                knr
                ksp
                kem
                justification
                updatedAt
            }
        }
    }
`);
